import { jsx as _jsx } from "react/jsx-runtime";
import FlexibleBannerWidget from "@widgets/flexibleBanner/FlexibleBannerWidget";
import darkWidgetBG from "@images/flexible-banner-dark.png";
import lightWidgetBG from "@images/flexible-banner-light.png";
const SeeAllLocationsWidget = ({ data }) => {
    const { theme, button, layout, title: rawTitle, description: rawDescription, backgroundImage: customBgImage, ...rest } = data;
    const themeBg = {
        dark: darkWidgetBG,
        light: lightWidgetBG
    };
    const backgroundImage = customBgImage !== null && customBgImage !== void 0 ? customBgImage : themeBg[theme];
    const title = rawTitle ? `<h2 style="text-align: center">${rawTitle}</h2>` : "";
    const description = rawDescription ? `<p style="text-align: center">${rawDescription}</p>` : "";
    const body = `${title}${description}`;
    return (_jsx(FlexibleBannerWidget, { data: {
            layout,
            backgroundImage,
            theme,
            description: body,
            primaryButton: {
                ...button,
                type: "secondary"
            },
            ...rest
        } }));
};
export default SeeAllLocationsWidget;
